import { useEffect } from "react";
import "./SuccessCreateIdModal.css";

const SuccessCreateIdModal = ({
  open,
  candidateName = "",
  employeeId = "",
  onBackToQueue,
}) => {
  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  if (!open) return null;

  const nameLabel = candidateName || "this candidate";

  return (
    <div className="rr-success-modal-backdrop" role="presentation">
      <div
        className="rr-success-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="rr-success-create-id-title"
        aria-describedby="rr-success-create-id-desc"
      >
        <div className="rr-success-modal__icon-wrap" aria-hidden="true">
          <span className="material-symbols-rounded rr-success-modal__icon">
            check_circle
          </span>
        </div>

        <h2
          id="rr-success-create-id-title"
          className="rr-success-modal__title"
        >
          Nice work — all clear!
        </h2>

        <p
          id="rr-success-create-id-desc"
          className="rr-success-modal__desc"
        >
          Every field for {nameLabel} checks out. Their employee ID has been
          created and onboarding is complete.
        </p>

        {employeeId ? (
          <div className="rr-success-modal__id-badge">{employeeId}</div>
        ) : null}

        <button
          type="button"
          className="btn p-btn p-btn-og rr-success-modal__btn"
          onClick={onBackToQueue}
        >
          <div className="p-btn-text">Back to queue</div>
        </button>
      </div>
    </div>
  );
};

export default SuccessCreateIdModal;
